<template>
  <popup-modal ref="popup" :modal-size="modalSize" :has-cancel-btn="hasCancelBtn" :has-title="hasTitle" :redirect-url="redirectUrl">
    <template v-slot:title>{{ title }}</template>
    <template v-slot:message>{{ message }}</template>
    <template v-slot:btnOKText>{{ btnOKText }}</template>
    <template v-slot:btnCancelText>{{ btnCancelText }}</template>
  </popup-modal>
</template>

<script>
import PopupModal from './PopupModal.vue'
import * as yup from "yup";
export default {
name: "ConfirmDialogue",
  components: { PopupModal },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener('showSehsehErrMsg', this.eventShow);
    });
  },
  beforeUnmount() {
    document.removeEventListener('showSehsehErrMsg', this.eventShow);
  },
  data: () => ({
    // Parameters that change depending on the type of dialogue
    title: "",
    message: "", // Main text content
    btnOKText: "",
    btnCancelText: "",
    modalSize: "lg",
    redirectUrl: "",

    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),

  provide () {
    return {
      clickOK: this.next
    }
  },

  methods: {
    eventShow(e) {
      console.log(e)
      // 要注意處理先確定物件是字串，濾掉特殊字元
      this.title = e.detail.title.toString();
      this.message = e.detail.message.toString();
      this.btnOKText = e.detail.btnOKText.toString();
      this.btnCancelText = e.detail.btnCancelText.toString();
      this.modalSize = e.detail.modalSize.toString();
      this.redirectUrl = e.detail.redirectUrl.toString();
      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open()
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    async next() {
      if (this.shouldRedirectAfterOK) {
        console.log("redirectUrl", this.redirectUrl);

        let that = this;
        await yup.string().url().isValid(that.redirectUrl)
            .then(function (valid) {
              console.log("redirectUrl after validator!", valid, that.redirectUrl);
              if (valid) {
                window.location.href = that.redirectUrl;
              }
            });

        console.log("after validator!");
      }
      this.$refs.popup.close();
    },

    _confirm() {
      this.$refs.popup.close()
      this.resolvePromise(true)
    },

    _cancel() {
      this.$refs.popup.close()
      this.resolvePromise(false)
      // Or you can throw an error
      // this.rejectPromise(new Error('User cancelled the dialogue'))
    },
  },

  computed: {
    hasCancelBtn () {
      return !!this.btnCancelText && this.btnCancelText.length > 0;
    },
    hasTitle () {
      return !(this.modalSize === "sm") && !!this.title && (this.title.length > 0);
    },
    shouldRedirectAfterOK () {
      return !!this.redirectUrl && this.redirectUrl.length > 0;
    }
  }
}
</script>

